import { ButtonLink, IButtonProps } from '@farmasiet/frontendcore-reactcomponents';
import React from 'react';

import { NavigationTracker, NavigationTrackerProps } from './NavigationTracker';

export const NavigationTrackerButtonLink = ({ disableTracking, source, href, onClick, ...props }: NavigationTrackerProps<IButtonProps> & IButtonProps) => (
    <NavigationTracker<IButtonProps> disableTracking={disableTracking} source={source} href={href} onClick={onClick}>
        {(href, onClick) => <ButtonLink href={href} onClick={onClick} {...props} />}
    </NavigationTracker>
);
